// extracted by mini-css-extract-plugin
export default {"customer":"customer_customer__EzdAC"};